import React, { useRef } from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import HouseVisitsDashboard from "../dashboard";
import { useSelector } from "react-redux";
import { IonRouterOutlet } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import Login from "../features/auth/Login";
import Forgot from "../features/auth/Forgot";
import LogOut from "../features/auth/LogOut";
import Verify from "../features/registration/Verify";
import ChangePassword from "../features/registration/ChangePassword";
import Loading from "../features/auth/Loading";

const RestrictedRoute = ({ location, component, ...rest }) => {
  // const hasAccess = useRoutePermission(location.pathname);
  // if (!hasAccess) {
  //   return <Redirect to="/unauthorized" />;
  // }
  console.log(location);
  return <Route {...rest} component={component} />;
};

const SecuredRoutes = ({ component: Component, routerRef, ...rest }) => {
  const profile = useSelector((state) => state.auth.profile);
  const isLoading = useSelector((state) => state.auth.loading);
  return profile ? (
    <Route
      {...rest}
      render={(routeProps) => (
        <Component {...routeProps} parentRef={routerRef} />
      )}
    />
  ) : isLoading ? (
    <Route path="/app/*" render={() => <Loading />} />
  ) : !profile ? (
    <Route path="/app/*" render={() => <Redirect to="/login" />} />
  ) : (
    null()
  );
};

const MobileRoutes = () => {
  const routerRef = useRef();
  const isLoading = useSelector((state) => state.auth.loading);
  const profile = useSelector((state) => state.auth.profile);
  return (
    <IonReactRouter>
      <IonRouterOutlet ref={routerRef}>
        <Route path={"/unauthorized"}>
          <div />
        </Route>
        <Route
          exact
          path="/"
          render={() =>
            isLoading ? (
              <Loading />
            ) : !profile ? (
              <Redirect to="/login" />
            ) : (
              <Redirect to="/app/" />
            )
          }
        />
        <SecuredRoutes
          path="/app"
          routerRef={routerRef}
          component={HouseVisitsDashboard}
        />
        <Route exact path="/login">
          <Login />
        </Route>
        <Route exact path="/forgot">
          <Forgot />
        </Route>
        <Route path="/logout">
          <LogOut />
        </Route>
        <Route path={"/verify_email"}>
          <Verify />
        </Route>
        <Route exact path={"/change_password"}>
          <ChangePassword />
        </Route>
      </IonRouterOutlet>
    </IonReactRouter>
  );
};

export default MobileRoutes;
